import { Button, IconButton, Tooltip, Grid } from "@mui/material"
import { useAppDispatch, useAppSelector } from "app/hooks"
import {
  selectCurrentRound,
  selectRounds,
  setRounds,
  setSelectedRound,
} from "app/roundSlice"
import { selectUser } from "app/userSlice"
import { OrderIdSearch } from "components/OrderIdSearch/OrderIdSearch"
import RoundSelector from "components/RoundSelector/RoundSelector"
import { ADMIN, hasPrivilege } from "constants/privileges"
import { fetchRounds } from "queries/fetchRounds"
import { useEffect, useState } from "react"
import { useLocation, useNavigate, Link } from "react-router-dom"
import { ALL, NavItem, navigationPages } from "./navigationPages"

export const TopNavigation = () => {
  const [activeMenu, setActiveMenu] = useState<string | null>(null)
  const [activeSubMenu, setActiveSubMenu] = useState<string | null>(null)
  const navigate = useNavigate()
  const loc = useLocation()
  const us = useAppSelector(selectUser)
  const selectedRound = useAppSelector(selectCurrentRound)
  const rounds = useAppSelector(selectRounds)
  const dispatch = useAppDispatch()

  useEffect(() => {
    fetchRounds().then((roundsGetResponse) => {
      if (roundsGetResponse?.roundsGet) {
        if (roundsGetResponse.roundsGet.rounds.length > 0) {
          dispatch(setRounds(roundsGetResponse.roundsGet.rounds))
          dispatch(setSelectedRound(roundsGetResponse.roundsGet.rounds[0]))
        }
      }
    })
  }, [dispatch])

  const handleMenuClick = (item: NavItem) => {
    if (item.children) {
      setActiveMenu(item.id)
      setActiveSubMenu(null)
      if (item.navTo !== undefined && item.navTo !== "") {
        window.scrollTo(0, 0)
        navigate(item.navTo)
      }
    } else {
      setActiveMenu(null)
      setActiveSubMenu(item.id)
      if (item.navTo !== undefined && item.navTo !== "") {
        window.scrollTo(0, 0)
        navigate(item.navTo)
      }
    }
  }

  const handleSubMenuClick = (subItem: NavItem) => {
    setActiveSubMenu(subItem.id)
    window.scrollTo(0, 0)
    // Navigation is now handled by the Link component
  }

  useEffect(() => {
    // find the current path in the pages array
    if (loc.pathname === "/") {
      setActiveMenu("1")
      setActiveSubMenu(null)
      return
    }
    if (loc.pathname.includes("/editArticle")) {
      setActiveMenu("Stammdaten")
      setActiveSubMenu("searchArticle")
      return
    }
    if (
      loc.pathname.includes("/editCustomer") ||
      loc.pathname.includes("/orderDetails")
    ) {
      setActiveMenu("serviceWorker")
      setActiveSubMenu("searchCustomer")
      return
    }
    for (const page of navigationPages) {
      if (page.navTo === loc.pathname) {
        setActiveMenu(page.id)

        break
      }
      if (page.children) {
        for (const child of page.children) {
          if (child.navTo === loc.pathname) {
            setActiveMenu(page.id)
            setActiveSubMenu(child.id)
            break
          }
        }
      }
    }
  }, [loc])

  return (
    <Grid container sx={{ mt: 1, marginRight: 5 }}>
      <Grid size={12}>
        <Grid container justifyContent="space-between">
          <Grid>
            {navigationPages.map(
              (item) =>
                (hasPrivilege(us.user?.privileges, item.userPrivilege) ||
                  item.userPrivilege === ALL ||
                  hasPrivilege(us.user?.privileges, ADMIN)) && (
                  <Tooltip title={item.label} key={item.id}>
                    <IconButton
                      color={"primary"}
                      onClick={() => handleMenuClick(item)}
                      sx={{
                        backgroundColor:
                          activeMenu === item.id ? "#7fb962" : "none",
                        color: activeMenu === item.id ? "#fff" : "#7fb962",
                        "&:hover": {
                          color: "#fff",
                          backgroundColor: "#7fb962",
                        },
                      }}
                    >
                      <item.Icon />
                    </IconButton>
                  </Tooltip>
                )
            )}
          </Grid>
          <Grid container justifyContent="flex-end" alignItems="center">
            {selectedRound &&
              (activeMenu === "1" || activeMenu === "rounds") && (
                <Grid>
                  <RoundSelector
                    rounds={rounds}
                    handleRoundSelectionChange={(round) => {
                      dispatch(setSelectedRound(round))
                    }}
                    selectedRound={selectedRound}
                  />
                </Grid>
              )}

            {activeMenu === "serviceWorker" && (
              <Grid>
                <OrderIdSearch size="small" />
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid container sx={{ minHeight: 48, flexWrap: "wrap" }}>
          {navigationPages.map((item) =>
            item.id === activeMenu && item.children
              ? item.children.map(
                (subItem) =>
                  (hasPrivilege(us.user?.privileges, subItem.userPrivilege) ||
                    subItem.userPrivilege === ALL ||
                    hasPrivilege(us.user?.privileges, ADMIN)) && (
                    <Button
                      key={subItem.id}
                      component={Link}
                      size="small"
                      to={subItem.navTo || "#"}
                      onClick={() => handleSubMenuClick(subItem)}
                      startIcon={<subItem.Icon />}
                      color={
                        activeSubMenu === subItem.id ? "secondary" : "primary"
                      }
                      sx={{
                        textDecoration: "none",
                        "&:hover": {
                          textDecoration: "none",
                        },
                      }}
                      onAuxClick={(e) => {
                        // Handle middle click (mouse wheel click) to open in new tab
                        if (e.button === 1 && subItem.navTo) {
                          e.preventDefault()
                          window.open(subItem.navTo, "_blank")
                        }
                      }}
                      onContextMenu={(e) => {
                        // Allow right-click context menu for "Open in new tab"
                        e.stopPropagation()
                      }}
                    >
                      {subItem.label}
                    </Button>
                  )
              )
              : null
          )}
          {!activeMenu && <Grid sx={{ minHeight: 48 }} />}
        </Grid>
      </Grid>
    </Grid>
  )
}
